// Client for the backend auto-sell bot. The backend holds the burner key and
// executes all live trades; the frontend never touches a private key.

const BASE = import.meta.env.VITE_BOT_API_URL || '';
const SECRET = import.meta.env.VITE_BOT_API_SECRET || '';

export const isBotConfigured = () => Boolean(BASE);

async function call(path, { method = 'GET', body } = {}) {
  if (!BASE) throw new Error('Backend bot URL not configured (VITE_BOT_API_URL)');
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      'x-bot-secret': SECRET,
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Bot API ${path} failed (${res.status})`);
  return data;
}

export const botApi = {
  health: () => call('/health'),
  getWallet: () => call('/wallet'),
  generateWallet: () => call('/wallet/generate', { method: 'POST' }),
  buy: ({ tokenAddress, amountSol, slippageBps }) =>
    call('/buy', { method: 'POST', body: { tokenAddress, amountSol, slippageBps } }),
  sell: ({ positionId, percentage }) =>
    call('/sell', { method: 'POST', body: { positionId, percentage } }),
  close: ({ positionId }) =>
    call('/close', { method: 'POST', body: { positionId } }),
  withdraw: ({ destination, amountSol }) =>
    call('/withdraw', { method: 'POST', body: { destination, amountSol } }),
};
